import { render, staticRenderFns } from "./PoIndomaret.vue?vue&type=template&id=707970e3&"
import script from "./PoIndomaret.vue?vue&type=script&lang=js&"
export * from "./PoIndomaret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports